import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import { Table, Pagination, Tooltip, Input, CheckboxTable, Modal, Button, Select } from 'components';
import { PinIcon, TrashIcon, ViewIcon, CleanIcon, AddWhiteIcon, TrashWhiteIcon, ConfirmIcon, StarIcon, GoogleMapsIcon, EditIcon } from 'assets/icons';
import { Globals, checkPermission, Constants } from 'utils';
import RequestQuote from '../request-quote';
import { ProfileService, ClientProfileService } from 'services';
import addCurrentLocation from 'google-maps-current-location';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const DEFAULT_LOCATION = {
	latitude: '10.48801',
	longitude: '-66.87919'
}

const INITIAL_STATE	= {
	state_id: '',
	city_id: '',
	municipality_id: '',
	address: '',
	indications: '',
	information: '',
	name: '',
	latitude: '',
	longitude: ''
}

declare var window: any;

// @ts-ignore
const google = window.google;

class ClientProfile extends React.Component<Props> {

	state = {
		form: {
			name: '',
			lastname: '',
			email: '',
			phone: '',
			document: '',
			tax_document: '',
			city: '',
			document_type_id: Constants.DOCUMENT_TYPES.V
		},
		map: null,
		marker: null,
		...DEFAULT_LOCATION,
		error_map: false,
		document_types: [],
		user_addresses: [],
		add_new: false,
		states: [],
		cities: [],
		municipalities: [],
		user_address: INITIAL_STATE,
		active_index: null,
		excluded_places: []
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Mi Perfil',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();		
	}

	requestLocation = async () => {
		await this.setState(DEFAULT_LOCATION);

  		if (google)
			this.setMap();
	}

	setMap = async () => {
		const map = new google.maps.Map(document.getElementById('map'), {
	      zoom: 13,
	      center: new google.maps.LatLng(this.state.user_address?.latitude || '10.48801',this.state.user_address?.longitude || '-66.87919'),
	      draggable: true,
	      zoomControl: true,
	      streetViewControl: false,
	      fullscreenControl: false,
	      scaleControl: false,
	      rotateControl: false
	    });

	    addCurrentLocation(map,{
		  markerStyle: {
			scale: 0
		  },
		  showAccuracyRadius: false
		});

	    const marker = new google.maps.Marker({
	      position: new google.maps.LatLng(this.state.user_address?.latitude || '10.48801',this.state.user_address?.longitude || '-66.87919'),
	      map,
	      title: 'Ubicación',
	      animation: google.maps.Animation.DROP,
	      draggable: true,
	      icon: PinIcon
	    })

	    await this.setState({
			map,
			marker
	    });

	    google.maps.event.addListener(marker,'dragend',(event: any) => {
	    	this.setState({
	    		user_address: {
	    			...this.state.user_address,
	    			latitude: event.latLng.lat(),
	    			longitude: event.latLng.lng()
	    		}
	    	});
	    });

	    google.maps.event.addListener(map,'click',(event: any) => {
	    	this.setState({
	    		user_address: {
	    			...this.state.user_address,
	    			latitude: event.latLng.lat(),
	    			longitude: event.latLng.lng()
	    		}
	    	});

	    	// @ts-ignore
	    	this.state.marker?.setPosition(new google.maps.LatLng(event.latLng.lat(),event.latLng.lng()));
	    });

	    const input = document.getElementById('location-input');
        const autocomplete = new google.maps.places.Autocomplete(input, {
        	componentRestrictions: {
        		country: "ve"
        	}
        });
        google.maps.event.addListener(autocomplete, 'place_changed', () => {
            var place = autocomplete.getPlace();
            const latitude = place.geometry.location.lat();
            const longitude = place.geometry.location.lng();
            this.setState({
            	user_address: {
            		...this.state.user_address,
            		latitude,
            		longitude
            	}
            });
            // @ts-ignore
            document.querySelector('#location-input').value = '';
            map.setCenter(new google.maps.LatLng(latitude,longitude));
            marker.setPosition(new google.maps.LatLng(latitude,longitude));
        });

        if (map) {
        	for (let i = 0; i < this.state.excluded_places.length; i++) {
	        	// @ts-ignore
	        	const coords = this.state.excluded_places[i].coords;

	        	new google.maps.Polygon({
			      paths: coords.map((i: any) => {
		    		return {
		    			lat: parseFloat(i.latitude),
		    			lng: parseFloat(i.longitude)
		    		}
			      }),
				  strokeColor: "#d20b06",
				  strokeOpacity: 0.8,
				  strokeWeight: 2,
				  fillColor: "#d20b06",
				  fillOpacity: 0.35,
				  map
			    });
	        }
        }
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await ProfileService.get({
			user_id: this.props.user.id
		});
		this.setState({
			document_types: res.document_types,
			user_addresses: res.user_addresses,
			form: {
				name: res.user.name || '',
				lastname: res.user.lastname || '',
				email: res.user.email || '',
				phone: res.user.phone || '',
				document: res.user.document || '',
				tax_document: res.user.tax_document || '',
				city: res.user.city || '',
				document_type_id: res.user.document_type_id || Constants.DOCUMENT_TYPES.V
			},
			states: res.states,
			excluded_places: res.excluded_places || []
		},async () => {
			this.requestLocation();
		});
	}

	submit = async (e: any) => {
		e.preventDefault();

		if (!this.state.form.document && [Constants.DOCUMENT_TYPES.V, Constants.DOCUMENT_TYPES.E].indexOf(this.state.form.document_type_id) != -1) {
			Globals.showError("El campo cédula es requerido");
			return;
		}

		if (!this.state.form.tax_document && [Constants.DOCUMENT_TYPES.J, Constants.DOCUMENT_TYPES.G].indexOf(this.state.form.document_type_id) != -1) {
			Globals.showError("El campo RIF es requerido");
			return;
		}

		const res: any = await ClientProfileService.client.save({
			user_id: this.props.user.id,
			...this.state.form,
			latitude: this.state.latitude,
			longitude: this.state.longitude
		});
		Globals.showSuccess("Se ha actualizado el perfil correctamente");
		if (res.user) {
			this.props.dispatch({
				type: 'SET_USER',
				payload: res.user
			});
		}
	}

	deleteAccount = async (e: any) => {
		e.preventDefault();
		Globals.confirm('¿Esta completamente seguro de eliminar su cuenta? Esta acción no se puede deshacer',async () => {
			await ClientProfileService.client.deleteAccount({
				user_id: this.props.user.id
			});
			this.props.dispatch({
				type: 'SET_USER',
				payload: null
			});
			this.props.history.replace('/client/quotes/request');
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	changeUserAddress = (e: any,callback = () => {}) => {
		this.setState({
			user_address: {
				...this.state.user_address,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	getCities = async () => {
		const res: any = await ProfileService.getCities({
			state_id: this.state.user_address.state_id,
			user_id: this.props.user?.id
		});
		this.setState({
			cities: res.cities,
			municipalities: res.municipalities
		});
	}

	add = () => {
		const {
			state_id,
			city_id,
			municipality_id,
			address,
			information,
			name,
			indications
		} = this.state.user_address;

		if (!state_id || !city_id || !municipality_id || !address || !name || !indications) {
			Globals.showError("Debe ingresar todos los datos para continuar");
			return;
		}

		for (let i = 0; i < this.state.excluded_places.length; i ++) {
			const place: any = this.state.excluded_places[i];

			const polygon = new google.maps.Polygon({
		      paths: place?.coords?.map((i: any) => {
	    		return {
	    			lat: parseFloat(i.latitude),
	    			lng: parseFloat(i.longitude)
	    		}
		      })
		    });

		    const center = new google.maps.LatLng(parseFloat(this.state.user_address?.latitude || '10.48801'),parseFloat(this.state.user_address?.longitude || '-66.87919'));

			const in_polygon = this.checkIfPolygonContains(
				center,
				polygon
			);

			if (in_polygon) {
				Globals.showError("Lo sentimos, la zona indicada en el mapa se encuentra fuera del área del servicio");
				return;
			}
		}

		let user_addresses: any = [...this.state.user_addresses];
		// @ts-ignore
		if (this.state.active_index != null && user_addresses[this.state.active_index]) {
			// @ts-ignore
			user_addresses[this.state.active_index] = this.state.user_address;
		}
		else {
			user_addresses.push(this.state.user_address);
		}
		this.setState({
			user_addresses,
			add_new: false,
			user_address: INITIAL_STATE,
			active_index: null
		},() => this.updateAddresses());
	}

	edit = (e: any, item: any, index: number) => {
		e.preventDefault();
		const user_address = this.state.user_addresses[index];
		this.setState({
			active_index: index,
			user_address,
			add_new: true
		},() => {
			setTimeout(() => {
				const element: any = document.getElementById('row-form');
			    if (element) {
			      window.scrollTo({ top: element.offsetTop - 100, behavior: 'smooth' });
			    }
			},100);	
			this.setMap();
			this.getCities();
		});
	}

	delete = (e: any, item: any, index: number) => {
		e.preventDefault();
		const user_addresses = this.state.user_addresses;
		user_addresses.splice(index,1);
		this.setState({
			user_addresses
		},() => this.updateAddresses());
	}

	updateAddresses = async () => {
		await ClientProfileService.client.updateAddresses({
			user_id: this.props.user?.id,
			user_addresses: JSON.stringify(this.state.user_addresses),
			withoutLoading: true
		});
	}

	checkIfPolygonContains = (coords: any,polygon: any) => {
		return google.maps.geometry.poly.containsLocation(coords, polygon);
	}
	
	render() {
		const { error_map, add_new } = this.state;

		return (
			<div id="client-profile">
				<div className="row">
					<div className="col-md-12">
						<BackComponent />

						<form onSubmit={ this.submit }>						
							<h3>Datos persona de contacto o empresa</h3>

							<div className="row">
								<div className="col-md-4">
									<Input
										color="white"
										value={ this.state.form.name }
										name="name" 
										label="Nombre"
										onChange={ this.change } />
								</div>
								<div className="col-md-4">
									<Input
										color="white"
										value={ this.state.form.lastname }
										name="lastname" 
										label="Apellido"
										onChange={ this.change } />
								</div>
								<div className="col-md-4">
									<label className="label-document" htmlFor="document_type_id">Cédula/RIF</label>
									<div className="container-document">
										<Select
											placeholder="Tipo de Documento"
											name="document_type_id"
											onChange={ (e: any) => {
												this.setState({
													form: {
														...this.state.form,
														document_type_id: parseInt(e.target.value)
													}
												});
											} }
											value={ this.state.form.document_type_id }
											options={ this.state.document_types.map((i: any) => {
												return {
													value: i.id,
													label: i.name
												}
											}) } />
										{
											[Constants.DOCUMENT_TYPES.V, Constants.DOCUMENT_TYPES.E].indexOf(this.state.form.document_type_id) != -1 && (
												<Input
													color="white"
													value={ this.state.form.document }
													name="document" 
													placeholder="Cédula"
													onChange={ this.change } />
											)
										}
										{
											[Constants.DOCUMENT_TYPES.J, Constants.DOCUMENT_TYPES.G].indexOf(this.state.form.document_type_id) != -1 && (
												<Input
													color="white"
													value={ this.state.form.tax_document }
													name="tax_document" 
													placeholder="RIF"
													onChange={ this.change } />
											)
										}
									</div>
								</div>
								<div className="col-md-4">
									<Input
										type="number"
										color="white"
										value={ this.state.form.phone }
										name="phone" 
										maxLength={ 11 }
										label="Teléfono"
										onChange={ this.change } />
								</div>
								<div className="col-md-4">
									<Input
										color="white"
										value={ this.state.form.email }
										name="email" 
										label="Correo Electrónico"
										onChange={ this.change } />
								</div>
							</div>

							<h3 className="title-address">Direcciones guardadas</h3>

							<div className="text-right">
								<a href="#" className="add-address" onClick={ (e: any) => {
									e.preventDefault();
									this.setState({
										add_new: true,
										active_index: null,
										user_address: INITIAL_STATE
									},() => {
										setTimeout(() => {
											const element: any = document.getElementById('row-form');
										    if (element) {
										      window.scrollTo({ top: element.offsetTop - 100, behavior: 'smooth' });
										    }
										},100);
										this.setMap();
									});
								} }>
									<img src={ AddWhiteIcon } />
									Añadir nueva dirección
								</a>
							</div>

							{
								this.state.user_addresses.length > 0 && (
									<Table data={ this.state.user_addresses.length } header={ [] }>
										{ this.state.user_addresses.map((i: any,index: number) => {
											return (
												<tr key={ index }>
													<td style={{ width: '30%' }}>
														<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i,index) }>
															<img src={ EditIcon } />
														</a>
														<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,i,index) }>
															<img src={ TrashIcon } />
														</a>
													</td>
													<td style={{ width: '35%' }} className="address">{ i.address }</td>
													<td style={{ width: '35%' }} className="name">{ i.name }</td>
												</tr>
											)
										}) }
									</Table>
								)
							}

							{
								this.state.user_addresses.length == 0 && !add_new && (
									<p className="no-addresses">No se han agregado direcciones</p>
								)
							}							
						</form>

						{
							add_new && (
								<React.Fragment>
									<div className="row" id="row-form" style={{ marginTop: '20px' }}>
										<div className="col-md-6">
											<Select
												label="Estado"
												name="state_id"
												onChange={ (e: any) => this.changeUserAddress(e,() => {
													this.setState({
														user_address: {
															...this.state.user_address,
															city_id: '',
															municipality_id: ''
														}
													},() => this.getCities());
												}) }
												value={ this.state.user_address.state_id }
												options={ this.state.states.map((i: any) => {
													return {
														value: i.id,
														label: i.name
													}
												}) } />
										</div>
										<div className="col-md-6">
											<Select
												label="Ciudad"
												disabled={ !this.state.user_address.state_id }
												name="city_id"
												onChange={ this.changeUserAddress }
												value={ this.state.user_address.city_id }
												options={ this.state.cities.map((i: any) => {
													return {
														value: i.id,
														label: i.name
													}
												}) } />
										</div>
										<div className="col-md-6">
											<Select
												label="Municipio"
												disabled={ !this.state.user_address.state_id }
												name="municipality_id"
												onChange={ this.changeUserAddress }
												value={ this.state.user_address.municipality_id }
												options={ this.state.municipalities.map((i: any) => {
													return {
														value: i.id,
														label: i.name
													}
												}) } />
										</div>
										<div className="col-md-6">
											<Input
												color="white"
												value={ this.state.user_address.address }
												name="address" 
												label="Dirección"
												placeholder="Indique la dirección completa"
												onChange={ this.changeUserAddress } />
										</div>
										<div className="col-md-6">
											<Input
												color="white"
												value={ this.state.user_address.indications }
												name="indications" 
												label="Indicaciones de la dirección"
												placeholder="Escribe aquí instrucciones o comentarios"
												onChange={ this.changeUserAddress } />
										</div>
										<div className="col-md-6">
											<Input
												color="white"
												value={ this.state.user_address.information }
												name="information" 
												label="Información adicional"
												placeholder="Ej: Piso/Oficina/Apto"
												onChange={ this.changeUserAddress } />
										</div>
										<div className="col-md-6">
											<Input
												color="white"
												value={ this.state.user_address.name }
												name="name" 
												label="Nombre de la dirección"
												placeholder="Nombre/Indicador de la dirección"
												onChange={ this.changeUserAddress } />
										</div>
									</div>

									{
										!error_map && (
											<React.Fragment>
												<label className="location-input-label">Indicar punto en el mapa</label>
												<input type="text" placeholder="Buscar dirección Google Mapas" id="location-input" />
											</React.Fragment>
										)
									}

									{
										!error_map && (
											<div id="map"></div>
										)
									}

									{
										error_map && (
											<div className="location-permission">
												<p>Para el correcto funcionamiento de la página debe permitir el acceso a su ubicación</p>
											</div>
										)
									}

									<div className="row row-address">
										<div className="col-6">
											<Button type="button" className="btn-cancel-address" onClick={ (e: any) => this.setState({
												...DEFAULT_LOCATION,
												add_new: false
											}) }>
												Cancelar
											</Button>
										</div>
										<div className="col-6">
											<Button type="button" className="btn-submit-address" onClick={ (e: any) => {
												e.preventDefault();
												this.add();
											} }>
												Guardar dirección
											</Button>
										</div>
									</div>
								</React.Fragment>
							)
						}						

						{
							!add_new && (
								<React.Fragment>
									<div className="text-center">
										<Button type="submit" onClick={ (e: any) => this.submit(e) }>
											Guardar
										</Button>
									</div>

									<div className="text-center">
										<Button type="button" className="btn-delete-account" onClick={ (e: any) => this.deleteAccount(e) }>
											Deseo eliminar mi cuenta
										</Button>
									</div>
								</React.Fragment>
							)
						}
					</div>
					{/*<div className="col-md-3">
						<RequestQuote />
					</div>*/}
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(ClientProfile);